import { render, staticRenderFns } from "./TimeSimple.vue?vue&type=template&id=d2a1dea8&scoped=true&"
import script from "./TimeSimple.vue?vue&type=script&lang=js&"
export * from "./TimeSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a1dea8",
  null
  
)

export default component.exports